import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { BoxIcons, DeleteOutlined, IconTypes } from "us.icons";
import {
  $Button,
  $DateLabel,
  $Popconfirm,
  $Tooltip,
} from "us.common/components";
import { getBoxIconByFileFormat } from "us.collection.documents/functions";
import { IReturnAction } from "us.common/interfaces";

type uploadedDocumentsProps = {
  documents: any;
  handleAttachment: (file: string, filePath: string) => void;
  deleteDocument: (<T>(data: Array<T> | object) => IReturnAction<T>) | undefined;
  values?: any; // Consider typing this more specifically
};

/**
 * @description - Pinned followups list item component
 */
const UploadedDocuments: React.FC<uploadedDocumentsProps> = ({
  documents,
  handleAttachment,
  values,
  deleteDocument,
}) => {
  const { t } = useTranslation();
  return documents?.map((document: any) => {
    const {
      documentName,
      documentPath,
      documentType,
      uploadedDate,
      documentId,
    } = document;
    return (
      <div key={documentId} className="msg-temp-thumb">
        {/* Newly uploaded document can be highlighted by adding "msg-temp-thumb-new" className here */}
        <div className="msg-temp-thumb-inner">
          <div
            className="msg-temp-thumb-content"
            onClick={() => handleAttachment(documentName, documentPath)}
          >
            <div className="msg-temp-thumb-icon">
              <BoxIcons
                type={IconTypes.BOX_ICON}
                name={getBoxIconByFileFormat("." + documentType)}
              />
            </div>
              <div className="msg-temp-thumb-desc">
                <div className="msg-temp-thumb-name">{documentName}</div>
                <div className="msg-temp-thumb-date">
                  <$DateLabel value={uploadedDate} />
                </div>
              </div>
          </div>
          <div className="msg-temp-thumb-options">
            <$Tooltip
              placement="top"
              title={t("US.COLLECTION.COMMON:COMMON.DELETE")}
            >
              <$Popconfirm
                title={t("US.COLLECTION.CASE:NOTESANDMESSAGES.SURE_TO_DELETE")}
                onConfirm={() => {
                  deleteDocument && deleteDocument({request: documentId, formValues: values});
                }}
                okText={t("US.COLLECTION.COMMON:COMMON.YES")}
                cancelText={t("US.COLLECTION.COMMON:COMMON.NO")}
              >
                <$Button type="link" size="small" danger>
                  <DeleteOutlined />
                </$Button>
              </$Popconfirm>
            </$Tooltip>
          </div>
        </div>
      </div>
    );
  });
};

export default memo(UploadedDocuments);
